import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../../firebase";

const GetAllBooks = async (uid, SchoolID) => {
  if (uid && SchoolID) {
    try {
      const LibraryCollection = collection(db, "Library");

      const q = query(
        LibraryCollection,
        where("uid", "==", uid),
        where("SchoolID", "==", SchoolID),
        where("IsDeleted", "==", false)
      );
      const LibrarySnapshot = await getDocs(q);

      let BooksData = [];

      LibrarySnapshot.forEach((doc) => {
        BooksData.push({ ...doc.data(), id: doc.id });
      });
      return BooksData;
    } catch (error) {
      console.log(error);
    }
  }
};

export default GetAllBooks;
